let lastScrollTop = 0;
const header = document.querySelector('.site-header');
const headerHeight = header.offsetHeight;
const scrollThreshold = headerHeight; // minimum scroll amount to trigger hide/show

function handleScroll() {
    if (!header) return;
    
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Determine scroll direction
    if (currentScroll > lastScrollTop && currentScroll > scrollThreshold) {
        header.style.transform = 'translateY(-100%)';
        header.style.transition = 'transform 0.3s ease-in-out';
        header.classList.remove('scroll-up');
    } else {
        header.style.transform = 'translateY(0)';
        header.style.transition = 'transform 0.3s ease-in-out';
        header.classList.add('scroll-up');

    }
    
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
}

// Throttle scroll events for better performance
let isScrolling;
window.addEventListener('scroll', () => {
    window.clearTimeout(isScrolling);
    isScrolling = setTimeout(handleScroll, 10);
});

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
    if (header) {
        header.style.position = 'fixed';
        header.style.width = '100%';
        header.style.top = '0';
        header.style.zIndex = '1000';
        document.body.style.paddingTop = `${headerHeight}px`; // Adjust body padding to prevent content from being hidden under the fixed header
    }
});
